export const firebaseConfig = {
  apiKey: "AIzaSyBQOAvLRmpUdb_wUZYwUMDyuztqApzAkuk",
  authDomain: "silence-farm-ec118.firebaseapp.com",
  databaseURL: "https://silence-farm-ec118.firebaseio.com",
  projectId: "silence-farm-ec118",
  storageBucket: "silence-farm-ec118.appspot.com",
  messagingSenderId: "188595089044",
  appId: "1:188595089044:web:8631633bde795835944e81",
  measurementId: "G-WNXJM7QKB2"
};